export default "__VITE_ASSET__BcQXDuGX__"